import React from 'react'
import styles from './Notification.module.scss'
import { NotificationProps } from './types'

const Notification = (props: NotificationProps) => <div ref={props.ref} className={styles['notification']}>{props.text}</div>

export default Notification
